import { useEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

/**
 * Portal
 *
 * Renders children into a dedicated node appended to `document.body`, above
 * the application shell. Used by overlays (modals, toasts) so their stacking
 * and clipping are independent of the layout tree.
 */
export function Portal({ children }: { children: ReactNode }) {
  const [host] = useState(() => {
    const el = document.createElement("div");
    el.setAttribute("data-portal", "");
    return el;
  });

  useEffect(() => {
    document.body.appendChild(host);
    return () => {
      document.body.removeChild(host);
    };
  }, [host]);

  return createPortal(children, host);
}
